export { LoyaltyHomeFaqXs } from './LoyaltyHomeFaqXs';
